import { useRef } from "react";
import QRCode from "react-qr-code";
import WhatsappIcon from "@/assets/imgs/whatsappIcon.png";
import CopyIcon from "@/assets/imgs/copyIcon.png";
import { HiddenShareQr } from "@/components/HiddenShareQr";

import { useOrder } from "@/_zustand/order";
import { useAuth } from "@/_zustand/auth";
import { useShareQrImage } from "@/hooks/useShareQrImage";
import { useSendQrEmail } from "@/hooks/useSendQrEmail";
import { dateToDDMMYYYY } from "@/lib";

export const OrderPage = () => {
  const { order } = useOrder();
  const { user } = useAuth();
  const message = `Hola, Soy ${user.usuario_nombre + " " + user.usuario_apellido} . ¡Quiero compartir contigo mi compra!.`;
  const encodedMessage = encodeURIComponent(message);
  const whatsappLink = `https://api.whatsapp.com/send?text=${encodedMessage}`;
  // qrRef solo se conserva como fuente de fallback (QR visible) para
  // HiddenShareQr.toPngBlob, si el nodo oculto no estuviera disponible.
  const qrRef = useRef(null);
  const { shareQrRef, isSharing, generateAndShare } = useShareQrImage({
    pedidoId: order.pedido_id,
    fallbackText: order.pedido_id,
  });
  const { email, setEmail, emailError, isSending, sendEmail } =
    useSendQrEmail({
      pedidoId: order.pedido_id,
      codigoQr: order.cadena,
      correoInicial: user.usuario_correo,
    });

  const handleCopy = () => {
    generateAndShare(qrRef.current?.querySelector("svg"));
  };

  const handleShareAndDownload = () => {
    // 1. Ejecutar la función que ya tienes para descargar/copiar el QR.
    // Esto asegura que el usuario tenga la imagen en su dispositivo.
    // Se dispara sin `await`: el trabajo de generación de la imagen es
    // asíncrono, pero el `window.open` de abajo debe ejecutarse de forma
    // síncrona en el mismo tick del click, o Safari/iOS lo bloquea como
    // popup no solicitado por el usuario.
    handleCopy();

    // 2. Abrir WhatsApp con el mensaje de texto predefinido.
    // Se usará la API de 'send' para abrir el selector de contactos.
    window.open(whatsappLink, "_blank");
  };

  return (
    <section id="pago" className="container my-5" style={{ flexGrow: 1 }}>
      {/* <div className="row border border-1 inter-regular text-black p-2 font14 mb-5 d-flex justify-content-between">
        <div className="col-12 col-sm-6 col-md-6 col-lg-6">
          <div className="text-start">
          <Link to="/" className="text-decoration-none">
            <svg 
            xmlns="http://www.w3.org/2000/svg"
            width={28}
            height={16}
            fill="currentColor"
            className="bi bi-geo-alt-fill"
            viewBox="0 2 18 18">
              <path d="M 12 2 A 1 1 0 0 0 11.289062 2.296875 L 1.203125 11.097656 A 0.5 0.5 0 0 0 1 11.5 A 0.5 0.5 0 0 0 1.5 12 L 4 12 L 4 20 C 4 20.552 4.448 21 5 21 L 9 21 C 9.552 21 10 20.552 10 20 L 10 14 L 14 14 L 14 20 C 14 20.552 14.448 21 15 21 L 19 21 C 19.552 21 20 20.552 20 20 L 20 12 L 22.5 12 A 0.5 0.5 0 0 0 23 11.5 A 0.5 0.5 0 0 0 22.796875 11.097656 L 12.716797 2.3027344 A 1 1 0 0 0 12.710938 2.296875 A 1 1 0 0 0 12 2 z"></path>
            </svg> &#187;
            </Link>{" "}
            <Link to={`/store/${machineSelected}`} className="text-decoration-none">
              {nameEmpresa ? <span>{nameEmpresa} &#187;</span> : <span> </span>}
            </Link>
          </div>
        </div>
        <div className="col-12 col-sm-6 col-md-6 col-lg-6">
          <div className="text-end">
            <i className="bi bi-geo-alt-fill"></i> {addressMachine}
          </div>
        </div>
      </div> */}
      <div className="row">
        {/* <HeaderImage />
      <div className="brand-header">
        <BrandInfo
          logoUrl={logoMachine}
          name={nameEmpresa}
          address={addressMachine}
          distance={"13km"}
        /> 
      </div> */}
        <div className="col-12 col-sm-12 col-md-12 col-lg-12 mb-3 inter-regular text-center">
          <div
            ref={qrRef}
            style={{
              height: "auto",
              margin: "0 auto",
              maxWidth: 250,
              width: "100%",
            }}
          >
            {order.cadena ? (
              <QRCode
                size={256}
                style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                value={order.cadena}
                // Sin viewBox: react-qr-code lo sobreescribe siempre con
                // "0 0 {módulos} {módulos}", así que pasarlo acá era código
                // muerto que no cambiaba nada.
              />
            ) : null}
          </div>
          <HiddenShareQr ref={shareQrRef} value={order.cadena} />
          <br />
          <h3 className="text-black inter-semibold ">¡Compra exitosa!</h3>
          <div className="order-success-text-flex">
            <p>ID de compra: {order.pedido_id}</p>
            <p>código válido hasta: {dateToDDMMYYYY(order.fecha)}</p>
          </div>
          <div className="order-success-text">
            <p>Guarda este código o envíalo a tu correo con el botón de abajo.</p>
            <p>Preséntalo en {order.maquina_direccion} y recibe tu compra</p>
          </div>
          <div className="order-success-buttons">
            <button
              className="order-btn-primary"
              onClick={handleShareAndDownload}
              disabled={isSharing}
            >
              Compartir
              <img
                src={WhatsappIcon}
                alt="carrito"
                className="order-btn-icon"
              />
            </button>
            <button
              className="order-btn-outline"
              onClick={handleCopy}
              disabled={isSharing}
            >
              Copiar código
              <img src={CopyIcon} alt="carrito" className="order-btn-icon" />
            </button>
          </div>
          <div className="order-success-text">
            <p>O si lo prefieres puedes</p>
          </div>
          <div className="order-success-text">
            <p>Reenviar por correo</p>
          </div>
          <div className="order-success-buttons">
            <div className="order-success-input" style={{ width: "65%" }}>
              <input
                type="email"
                placeholder="tu@correo.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                aria-invalid={Boolean(emailError)}
                aria-describedby={emailError ? "order-email-error" : undefined}
              />
              {emailError ? (
                <p id="order-email-error" className="text-danger font12 mb-0">
                  {emailError}
                </p>
              ) : null}
            </div>
            <button
              className="order-btn-outline"
              onClick={() => sendEmail()}
              disabled={isSending}
            >
              {isSending ? "Enviando…" : "Enviar código"}
            </button>
          </div>
        </div>

        {/* <div className="col-12 col-sm-6 col-md-6 col-lg-6">
          <div className="row border rounded-3 bg-light p-3">
            <div className="col-12">
              <h5 className="inter-semibold text-black">Pago exitoso</h5>
              <p className="inter-regular font14">Su pago se ha realizado exitosamente</p>
            </div>

            <div className="col-12 rounded border bg-white mb-3">
              <div className="row d-flex justify-content-between">
              </div>
            </div>

            <div className="col-12">
              <div className="row inter-semibold text-black" style={{ fontSize: 20 }}>
                <div className="col-6 text-start"><p>Subtotal</p></div>
                <div className="col-6 text-end"><p>{ formatMoney(order.pedido_total)}</p></div>
              </div>
            </div>
            <hr />
            <div className="col-12 text-end">
              <Link 
              to={`/store/${machineSelected}`}
              reloadDocument = {true}
              >
                
                <Button className="inter-semibold mx-4" variant="secondary">
                  Seguir comprando
                </Button>
              </Link>
            </div>
            {/* <div className="col-12 text-end">
              <button type="button" className="btn verde text-white inter-semibold">
                Pagar $ 73.980
              </button>
            </div>
          </div>
        </div> */}
      </div>
    </section>
  );
};
